<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>David Burton has lived in County Durham all of his life and was schooled and educated there also. He has a passion and desire for stories and storytelling. From reading to films and later to writing. A desire to turn the most simplistic situation and character into a tale; to create heroes and villains from the ordinary. David still regards himself as being in continuous education.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?78b9b200